import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { EngineProvider, OwnerValidationProvider, PinProvider, ShareVehicleProvider, VehiclesProvider } from 'context'
import { AnimatePresence } from 'framer-motion'

import AdminLayout from 'components/AdminLayout'
import {
  AddContactShareVehicle,AddVehicleWithPlateNumber,Appointment, Billing, ConfirmToPin, ContractSubscription,
  CreatePin, DetailShareVehicle, HireWicar, MyVehicles, OwnerValidation, PaymentResult, RecoverVehicle,
  RequestPermissionsShareVehicle, ResetPin, SubscriptionInfo } from 'pages'
import { AddVehicleWithCarCode } from 'pages/AddVehicleWithCarCode'


const DashboardClientsRoutes = () => {
  const location = useLocation()

  return (
    <VehiclesProvider>
      <EngineProvider>
        <PinProvider>
          <OwnerValidationProvider>
            <ShareVehicleProvider>
              <AnimatePresence exitBeforeEnter>
                <AdminLayout key={location.pathname}>
                  <Routes location={location} key={location.pathname}>
                    <Route path="/my-vehicles" element={<MyVehicles />} />
                    <Route path="/confirm-to-pin" element={<ConfirmToPin />} />
                    <Route path="/owner-validation" element={<OwnerValidation />} />
                    <Route path="/new-subscription" element={<AddVehicleWithPlateNumber />} />
                    <Route path="/add-vehicle" element={<AddVehicleWithCarCode />} />
                    <Route path="/hire-wicar" element={<HireWicar />} />
                    <Route path="/subscription-info" element={<SubscriptionInfo />} />
                    <Route path="/contract-subscription" element={<ContractSubscription />} />
                    <Route
                      path="/payment-result/:plate/:isOnlyRenew/:appointment/:renewAutomatic/:result"
                      element={<PaymentResult />} />
                    <Route path="/appointment" element={<Appointment />} />
                    <Route path="/recover-vehicle" element={<RecoverVehicle />} />
                    <Route path="/reset-pin" element={<ResetPin />} />
                    <Route path="/create-pin" element={<CreatePin />} />
                    <Route path="/detail-share-vehicle" element={<DetailShareVehicle />} />
                    <Route path="/add-contact-share-vehicle" element={<AddContactShareVehicle />} />
                    <Route path="/request-permissions-share-vehicle" element={<RequestPermissionsShareVehicle />} />
                    <Route path="/billing" element={<Billing />} />
                    <Route path="*" element={<Navigate to='/' />} />
                  </Routes>
                </AdminLayout>
              </AnimatePresence>
            </ShareVehicleProvider>
          </OwnerValidationProvider>
        </PinProvider>
      </EngineProvider>
    </VehiclesProvider>
  )
}

export default DashboardClientsRoutes
